import { DocumentEntity, CallType } from "__generated__/enums";

export enum VoyageTabs {
	Details = "details",
	Charters = "charters",
	Scope = "scope",
	Reefer = "reefer",
	VoyageLog = "voyagelog",
	Documents = "documents",
	Tanks = "tanks",
	Planning = "planning"
}

export enum VoyageCallFormTabs {
	Details = "details",
	Expected = "expected-containers"
}

export const actionTypeToDocumentType = (type: CallType) => {
	switch (type) {
		case CallType.Loading:
			return DocumentEntity.LoadingCargo;
		case CallType.Discharging:
			return DocumentEntity.DischargingCargo;
		case CallType.LoadingDischarging:
			return DocumentEntity.Cargo;
		case CallType.Cleaning:
			return DocumentEntity.TankCleaning;
		case CallType.NitrogenPurging:
			return DocumentEntity.NitrogenPurging;
		default:
			return undefined;
	}
};
